import { SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { DoDontCard } from './DoDontCard';

interface DoDontCardsProps {
  dos: string;
  donts: string;
  onDosChange: (dos: string) => void;
  onDontsChange: (donts: string) => void;
}

/**
 * The "À faire" / "À éviter" pair, shared by the template editor and the
 * invitation wizard, with the one line saying how the creator reads them.
 */
export const DoDontCards = ({ dos, donts, onDosChange, onDontsChange }: DoDontCardsProps) => {
  const { t } = useTranslation();

  return (
    <VStack align="stretch" gap="1.5">
      <SimpleGrid columns={{ base: 1, md: 2 }} gap="2.5">
        <DoDontCard
          kind="dos"
          title={t('collabs.briefTemplates.sections.guidelines.dos.title')}
          placeholder={t('collabs.briefTemplates.sections.guidelines.dos.placeholder')}
          value={dos}
          onChange={onDosChange}
        />
        <DoDontCard
          kind="donts"
          title={t('collabs.briefTemplates.sections.guidelines.donts.title')}
          placeholder={t('collabs.briefTemplates.sections.guidelines.donts.placeholder')}
          value={donts}
          onChange={onDontsChange}
        />
      </SimpleGrid>
      <Text fontSize="10.5px" color="fg.muted" lineHeight="1.4">
        {t('collabs.briefTemplates.sections.guidelines.items.help')}
      </Text>
    </VStack>
  );
};
